import { OutputRow as SessionTypesData } from "api/getSessionTypes";
import { makeSubmitEditableTableChanges } from "api/makeApiRequestType/makeSubmitEditableTableChanges";

export const saveSessionTypes = makeSubmitEditableTableChanges<
	SessionTypesData
>("sessionTypes");
